import React from "react";
import { Table } from "antd";

const DataTable = ({ columns, dataSource, rowKey = "id", loading = false }) => (
  <Table
    className="table datanew dataTable no-footer"
    columns={columns}
    dataSource={dataSource}
    rowKey={rowKey}
    loading={loading}
    pagination={{ pageSize: 10, showSizeChanger: true }}
  />
);

export default DataTable;
